import axios from './axios'

export const fetchCSRFToken = async () => {
  try {
    const res = await axios.get('/csrf')
    if (res?.status === 200) return res.data._csrf
  } catch (error) {}
}
